<p-dialog [style]="{width: '80vw'}" [(visible)]="isVisible" appendTo="body" (visibleChange)="dialogVisibleChange($event)" [modal]="true" [resizable]="false" [draggable]="false">
  <p-header>{{ 'TariffRateImport.Header' | translate }}</p-header>
  <div class="mt-2">
    <form class="detail-form" [formGroup]="importForm">
      <div class="p-fluid formgrid grid">
        <div class="field grid col-4 align-items-baseline">
          <label class="col-2 column-label">{{ 'TariffRateImport.Forwarder' | translate }} </label>
          <div class="col-10 column-value">
            <p-dropdown formControlName="forwarder" [filter]="true" filterBy="label" [options]="forwarderOptions" [(ngModel)]="forwarder"  optionValue="value"></p-dropdown>
          </div>
        </div>
      </div>
    </form>
    <h4>{{ 'TariffRateImport.File' | translate }}</h4>
    <div class="container">
      <div class="formgrid grid">
          <div class="field col-12">
            <p-fileUpload #fileUpload [customUpload]="true" (uploadHandler)="fileUploader($event)" chooseLabel="{{ 'TariffRateImport.Select' | translate }}" uploadLabel="{{ 'TariffRateImport.Import' | translate }}" cancelLabel="{{ 'TariffRateImport.Cancel' | translate }}">
              <ng-template pTemplate="toolbar">
                <button pButton pRipple label="{{ 'TariffRateImport.TemplateDownload' | translate }}" (click)="templateDownloadClickBtn($event)" class="ml-2"></button>
              </ng-template>
            </p-fileUpload>
          </div>
      </div>
    </div>
    <div class="mt-2">
      <laas-data-table [tableKey]="preferenceKey" [selectable]="false" [dataKey]="'seqNo'" [value]="tariffRateRows" [defaultColumns]="columns" [loading]="isLoading">
        <ng-template pTemplate="caption">
          <button pButton pRipple label="{{ 'TariffRateImport.Upload' | translate }}" [disabled]="tariffRateRows.length === 0" (click)="importClickBtn($event)" class="ml-2"></button>
          </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchDefault>
                <div [ngSwitch]="col.dataType">
                  <ng-container *ngSwitchCase="'date'">
                    <div class="overflow-text">
                      {{ rowData[col.field] | date:'yyyy-MM-dd':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <div class="overflow-text">
                      {{ rowData[col.field] | replaceNullWith:'-'}}
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>
          </td>
        </ng-template>
      </laas-data-table>
    </div>
  </div>
</p-dialog>
